import { render, staticRenderFns } from "./TargetFamilyDetailTable.vue?vue&type=template&id=300b3aa6&lang=pug"
import script from "./TargetFamilyDetailTable.vue?vue&type=script&lang=ts"
export * from "./TargetFamilyDetailTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports